module.exports = __webpack_public_path__ + "static/img/08_報名活動.dbafab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/08_報名活動.png
// module id = dGdk
// module chunks = 1